module.exports = __webpack_public_path__ + "static/media/coffee-latte-mb-fr.81e76a7a.mp4";